import { DialogContent, Grid } from '@mui/material';
import { FC } from 'react';
import { FormProvider, FieldValues, useForm } from 'react-hook-form';
import { WsButton, WsDialog, WsSelect, WsTypography, WsTypoVariants } from 'wisestep-base';

import { HeaderBox } from '../../jobSettings/components/HeaderBox';

import { action, AddActionButtonDropDown } from './helper';

export interface AddActionButtonDialogProps {
  openDialog: boolean;
  closeDialog(): void;
  onChangeHandler: (data: action) => void;
}
const AddActionButtonDialog: FC<AddActionButtonDialogProps> = ({
  openDialog,
  closeDialog,
  onChangeHandler,
}) => {
  const methods = useForm();
  const updaterFunction = (data: FieldValues) => {
    onChangeHandler(data.action);
    closeDialog();
  };
  return (
    <WsDialog openDialog={openDialog} size="small">
      <DialogContent>
        <HeaderBox>
          <WsTypography variant={WsTypoVariants.SUB_TITLE}>Add Action Button</WsTypography>
          <WsButton onClick={() => closeDialog()}>Close</WsButton>
        </HeaderBox>

        <Grid container direction="column" mt={2}>
          <FormProvider {...methods}>
            <WsSelect
              required={true}
              name="action"
              label="Action"
              selectArray={AddActionButtonDropDown}
            />
            <WsButton
              onClick={methods.handleSubmit((data: FieldValues) => updaterFunction(data))}
              type="submit"
            >
              Add
            </WsButton>
          </FormProvider>
        </Grid>
      </DialogContent>
    </WsDialog>
  );
};
export default AddActionButtonDialog;
